import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";

const ItemsToRecalculateTable = ({ items }) => {
  if (!items || items.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" align="center">
        No items require recalculation at this time.
      </Typography>
    );
  }

  const formatValueRange = (min, max) => {
    if (min === null && max === null) return "-";
    if (min === max) return min;
    return `${min}-${max}`;
  };

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell><strong>ID</strong></TableCell>
          <TableCell><strong>Name</strong></TableCell>
          <TableCell><strong>Current Value</strong></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((item) => (
          <TableRow key={item.id}>
            <TableCell>{item.id}</TableCell>
            <TableCell>{item.name}</TableCell>
            <TableCell>
              {formatValueRange(item.current_value_min, item.current_value_max)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ItemsToRecalculateTable;